import { Box, Button, Container, Flex, Text, TextInput } from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import { MantineReactTable } from "mantine-react-table";
import moment from "moment";
import { useState, useMemo } from "react";
import AppBreadcrumb from "components/AppBreadcrumb";
import { report_api } from "./report.service";
import { showErrorToast, showSuccessToast } from "utilities/Toast";

export default function OrderStatusReport() {
  const [orderId, setOrderId] = useState("");
  const [date, setDate] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [disableOrder, setDisableOrder] = useState(false);
  const [disableDate, setDisableDate] = useState(false);


const fetchOrderStatus = async () => {
  setLoading(true);
  const payload = {};

  if (!orderId && !date) {
    showErrorToast("Please enter Order Number or Date");
    setLoading(false);
    return;
  }

  if (orderId) payload.order_id = orderId;
  if (date) payload.date = moment(date).format("YYYY-MM-DD");

  const response = await report_api.get_order_status(payload);

  if (response.success) {
    if (response.data.length === 0) {
      showErrorToast({ title: "Error", message:"No data found for this search" });
    }
    setTableData(response.data || []);
  } else {
    showErrorToast("Something went wrong");
    setTableData([]);
  }

  setLoading(false);
};


  const columns = useMemo(
    () => [
      {
        header: "Order No",
        accessorKey: "order_id",
        size:"auto",
      },
      {
        header: "Delivery Boy",
        accessorKey: "delivery_boy",
        size:"auto",
        Cell: ({ cell }) => cell.getValue() || "NA",
      },
      {
        header: "Payment Status",
        accessorKey: "payment_mode",
        size:"auto",
        Cell: ({ cell }) => {
          const mode = cell.getValue();
          return (
            <span
              style={{
                color: mode ? "green" : "red",
                fontWeight: 600,
              }}
            >
              {mode ? "Completed" : "Pending"}
            </span>
          );
        },
      },
      {
        header: "Packed",
        size:"auto",
        accessorFn: (row) => row.packed_time,
        Cell: ({ cell }) =>
          cell.getValue()
            ? moment(cell.getValue()).format("DD-MM-YYYY hh:mm A")
            : "NA",
      },
      {
        header: "Out for Delivery",
        size:"auto",
        accessorFn: (row) => row.out_for_delivery_time,
        Cell: ({ cell }) =>
          cell.getValue()
            ? moment(cell.getValue()).format("DD-MM-YYYY hh:mm A")
            : "NA",
      },
      {
        header: "Delivered",
        size:"auto",
        accessorFn: (row) => row.delivered_time,
        Cell: ({ cell }) =>
          cell.getValue()
            ? moment(cell.getValue()).format("DD-MM-YYYY hh:mm A")
            : "NA",
      },
      {
        header: "Cancelled",
        size:"auto",
        accessorFn: (row) => row.cancelled_time,
        Cell: ({ cell }) =>
          cell.getValue()
            ? moment(cell.getValue()).format("DD-MM-YYYY hh:mm A")
            : "NA",
      },
    //   {
    //     header: "Delivery Boy",
    //     accessorKey: "delivery_boy",
    //   },
      {
        header: "DB Ph.No",
        accessorKey: "delivery_boy_phno",
        size:"auto",
        Cell: ({ cell }) => cell.getValue() || "NA",
      },
      {
        header: "CC Ph.No",
        accessorKey: "counter_contact_number",
        size:"auto",
        Cell: ({ cell }) => cell.getValue() || "NA",
      },
    ],
    []
  );

  return (
    <>
      <Container fluid>
        <Box p={25}>
          <Flex justify={"space-between"} align="end">
            <Box>
              <Text size={"lg"} fw={600} mb={10}>
                Order Status Report
              </Text>
              <AppBreadcrumb />
            </Box>
          </Flex>
        </Box>
      </Container>

      <Container fluid>
        <Box p={25} mt={-20}>
          <Flex gap={10} align={"end"} wrap={"wrap"}>
            <TextInput
               label="Order Number"
               placeholder="Enter Order No"
               value={orderId}
               onChange={(e) => {
                 const val = e.target.value;
                 setOrderId(val);             

                 if (val.length > 0) {
                   setDisableDate(true);      // disable date picker
                 } else {
                   setDisableDate(false);     // enable date picker
                 }
               }}
               rightSection={
                 orderId && (
                   <span
                     style={{ cursor: "pointer", fontSize:"12px", paddingRight: 5 }}
                     onClick={() => {
                       setOrderId("");
                       setDisableDate(false);  // enable date picker
                     }}
                   >
                     ✕
                   </span>
                 )
               }
               disabled={disableOrder}
               style={{ width: "250px" }}
             />


            <DatePickerInput
                label="Date"
                placeholder="Select Date"
                value={date}
                onChange={(d) => {
                  setDate(d);
              
                  if (d) {
                    setDisableOrder(true);     // disable orderId input
                  } else {
                    setDisableOrder(false);    // enable orderId input
                  }
                }}
                clearable
                disabled={disableDate}
                style={{ width: "250px" }}
              />

            <Button
              onClick={fetchOrderStatus}
              loading={loading}
              style={{ marginTop: "6px" }}
            >
              Search
            </Button>
          </Flex>
        </Box>
      </Container>

      <Container fluid mt={10} mb={30}>
        <Box px={25} sx={{ borderRadius: 2 }}>
          <Box className="datatable-wrapper">
            <MantineReactTable
              columns={columns}
              data={tableData}
              initialState={{ density: "xs" }}
              enableStickyHeader
              enableGlobalFilter={false}
              enableColumnFilters={false}
              enableDensityToggle={false}
              enableFullScreenToggle={false}
              enableColumnActions={false}
              mantineTableProps={{ className: "datatable" }}
              renderTopToolbarCustomActions={() => (
                <Box px={5} py={10}>
                  <Text
                    fw={600}
                    tt="uppercase"
                    size="sm"
                    sx={(theme) => ({
                      letterSpacing: 1,
                      color: theme.colors.brand[7],
                    })}
                  >
                    Order Status List
                  </Text>
                </Box>
              )}
            />
          </Box>
        </Box>
      </Container>
    </>
  );
}
